import type { BoxProps } from '@chakra-ui/react';
import { Box, Flex, Image } from '@chakra-ui/react';
import smileFaceSvg from '@public/images/how-it-works-agents/smile-face.svg';

import { BannerContent } from './BannerContent';

export const Banner = (props: BoxProps) => {
  return (
    <Box {...props}>
      <Flex
        flexDir="column"
        bg={{
          base: `url(${smileFaceSvg.src}) top -30px left -20px / 100px auto no-repeat, url(/images/how-it-works-agents/mask-bg.png) top left / cover no-repeat {colors.secondary.persianBlue}`,
          desktop: `url(${smileFaceSvg.src}) top -100px left 120px no-repeat, url(/images/how-it-works-agents/mask-bg.png) center left / cover no-repeat {colors.secondary.persianBlue}`,
        }}
        px="20px"
        pt="20px"
        pb={{
          base: '30px',
          desktop: '50px',
        }}
        alignItems="center"
        position="relative"
        overflow="hidden"
      >
        <Image
          boxSize={{
            base: '100px',
            desktop: '230px',
          }}
          src={smileFaceSvg.src}
          alt="how it works"
          position="absolute"
          ml={{ base: '300px', desktop: '810px' }}
          bottom={{
            base: '-40px',
            desktop: '-120px',
          }}
          transform="rotate(-30deg)"
          draggable={false}
          userSelect="none"
        />
        <BannerContent />
      </Flex>
      <Box
        w="full"
        h="20px"
        mt="-10px"
        bg="url(/images/how-it-works-agents/star-line.png) left top / auto 20px repeat"
        position="relative"
      />
    </Box>
  );
};
